import { render, staticRenderFns } from "./Annuality.vue?vue&type=template&id=2f8d1bf4&scoped=true&"
import script from "./Annuality.vue?vue&type=script&lang=js&"
export * from "./Annuality.vue?vue&type=script&lang=js&"
import style0 from "./Annuality.vue?vue&type=style&index=0&id=2f8d1bf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8d1bf4",
  null
  
)

export default component.exports